export default function convertImageBase64(w: number, h: number) {
  const content = `
  <svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient id="g">
        <stop stop-color="#e0e0e0" offset="20%" />
        <stop stop-color="#c0c0c0" offset="50%" />
        <stop stop-color="#e0e0e0" offset="70%" />
      </linearGradient>
    </defs>
    <!-- Background Rectangle -->
    <rect width="${w}" height="${h}" fill="#e0e0e0" rx="8" ry="8" />
    <!-- Animated Gradient Rectangle -->
    <rect id="r" width="${w}" height="${h}" fill="url(#g)" rx="8" ry="8" />
    <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite" />
  </svg>`;

  return typeof window === 'undefined'
    ? Buffer.from(content).toString('base64')
    : window.btoa(content);
}
